<template>
<!-- 页脚 -->
  <div>
    <!-- 上部分 -->
    <div class="top">
      <div class="topt">
        <div class="flex-items-between">
          <div>
            <img src='@/image/logof.png'/>
          </div>
          <div>
            <div>厦门市佐云佑网科技有限公司</div>
            <div style="margin-top: 6px">厦门市集美区软件园三期F10</div>
          </div>
        </div>
      </div>
      <div class="topb">
        <div>联系我们</div>
        <!-- class='flex-between' -->
        <div>
          <div>电话：18959215659</div>
          <div>邮箱：zo-cloud@zocloud.com</div>
        </div>
      </div>
    </div>

    <!-- 下部分 -->
    <div class="footer">
      <div>Copyright &copy; 2024 佐云科技 All Rights Reserved</div>
      <div>
        <a href="https://beian.miit.gov.cn/" target="_blank">闽ICP备 2022017262号</a>
      </div>
      <div>
        <el-image :src="beian" style="width: 12px;margin: 0 3px -9px 0 ;"></el-image>
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=35021102002086" rel="noreferrer" target="_blank">闽公网安备 35021102002086号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nav-footer',
  data() {
    return {
      beian: require('@/assets/beian.png'),
    }
  },
  methods:{

  }
}
</script>

<style scoped lang="scss">
.top{
  background-color: #1a3a66;
  font-size:14px;
  padding: 0 20px;
  color: #4c76b9;
  .topt {
    border-bottom: 1px solid #2d4e82;
    padding: 35px 0 30px;
    img {
      width: 120px;
      margin-left: 6px;
    }
  }
  .topb {
    padding: 20px 5px;
    line-height: 25px;
  }
}

.footer{
  background-color: #132f55;
  text-align:center;
  font-size: 14px;
  color: #426094;
  line-height: 22px;
  padding: 25px 0 20px;
}
// 去下划线（包含下面四种）
// a:link,a:visited,a:hover,a:active
a{
  text-decoration: none;
  color: #426094;
  line-height: 22px;
}
</style>


